<template>
  <div>
    <div class="main-title">充值卡列表</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button type="primary" @click="addFormVisible = true">添加新充值卡</el-button>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索卡号"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              @input="inputSearch(searchForm)">
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        style="width:100%">
        <el-table-column
          prop="id"
          label="系统编号"
          width="80">
        </el-table-column>
        <el-table-column
          prop="card_no"
          label="充值卡卡号"
          width="220">
        </el-table-column>
        <el-table-column
          prop="card_name"
          label="持卡人">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号">
        </el-table-column>
        <el-table-column
          prop="recharge"
          label="累计充值">
        </el-table-column>
        <el-table-column
          prop="consume"
          label="累计消费">
        </el-table-column>
        <el-table-column
          prop="balance"
          label="当前余额">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="detail(scope.row)">明细</el-button>
            <el-dropdown>
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="recharge(scope.row)">充值</el-dropdown-item>
                <el-dropdown-item @click.native="transfer(scope.row)">转账</el-dropdown-item>
                <el-dropdown-item @click.native="changePhone(scope.row)">修改手机号</el-dropdown-item>
                <el-dropdown-item @click.native="changePassword(scope.row)">修改密码</el-dropdown-item>
                <el-dropdown-item @click.native="resetPassword(scope.row)">重置密码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
      <!-- 添加新卡 -->
      <el-dialog title="添加新充值卡" :visible.sync="addFormVisible">
        <el-form :model="addForm" ref="addForm" :rules="addFormRules" label-width="200px">
          <el-form-item prop="card_no" label="卡号">
            <el-input v-model="addForm.card_no" style="width:194px;"></el-input>
          </el-form-item>
          <el-form-item prop="card_name" label="持卡人">
            <el-input v-model="addForm.card_name" style="width:194px;"></el-input>
          </el-form-item>
          <el-form-item prop="phone" label="手机号">
            <el-input v-model.number="addForm.phone" style="width:194px;"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addFormCommit" :loading="addFormCommiting">确 定</el-button>
          <el-button @click="addFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 充值 -->
      <el-dialog title="充值" :visible.sync="rechargeFormVisible">
        <el-form :model="rechargeForm" ref="rechargeForm" :rules="rechargeFormRules" label-width="200px">
          <el-form-item label="卡号">
            {{ rechargeForm.card_no }}
          </el-form-item>
          <el-form-item label="持卡人">
            {{ rechargeForm.card_name }}
          </el-form-item>
          <el-form-item prop="pay_money" label="实收金额">
            <el-input v-model.number="rechargeForm.pay_money" @input="countOperMoney" @change="updateRechargeRemark" style="width:194px;"></el-input>
          </el-form-item>
          <el-form-item prop="free_rate" label="赠送率" v-if="user.group_id == 1">
            <el-select v-model="rechargeForm.free_rate" @change="countOperMoney">
              <el-option label="0" :value="1"></el-option>
              <el-option label="5%" :value="1.05"></el-option>
              <el-option label="10%" :value="1.1"></el-option>
              <el-option label="15%" :value="1.15"></el-option>
              <el-option label="20%" :value="1.2"></el-option>
              <el-option label="25%" :value="1.25"></el-option>
              <el-option label="30%" :value="1.3"></el-option>
              <el-option label="35%" :value="1.35"></el-option>
              <el-option label="40%" :value="1.4"></el-option>
              <el-option label="45%" :value="1.45"></el-option>
              <el-option label="50%" :value="1.5"></el-option>
              <el-option label="55%" :value="1.55"></el-option>
              <el-option label="60%" :value="1.6"></el-option>
              <el-option label="65%" :value="1.65"></el-option>
              <el-option label="70%" :value="1.7"></el-option>
              <el-option label="80%" :value="1.8"></el-option>
              <el-option label="90%" :value="1.9"></el-option>
              <el-option label="100%" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="free_money" label="赠送金额" v-if="user.group_id == 1">
            <el-input v-model.number="rechargeForm.free_money" style="width:194px;" disabled></el-input>
          </el-form-item>
          <el-form-item prop="oper_money" label="充值金额">
            <el-input v-model.number="rechargeForm.oper_money" @change="updateRechargeRemark" style="width:194px;"></el-input>
          </el-form-item>
          <el-form-item label="支付方式">
            <el-select v-model="rechargeForm.pay_type" placeholder="请选择支付方式" @change="payTypeChange" style="width:194px;">
              <el-option label="现金" value="现金"></el-option>
              <el-option label="支付宝" value="支付宝"></el-option>
              <el-option label="微信支付" value="微信支付"></el-option>
              <el-option label="刷卡" value="刷卡"></el-option>
              <el-option label="转账" value="转账"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收款账户">
            <el-select v-model="rechargeForm.fin_account" placeholder="请选择账户" style="width:194px;">
              <el-option v-for="i in accountListFilter" :key="i.id" :label="i.name" :value="i.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款人">
            <el-input v-model="rechargeForm.fin_person" style="width:194px;"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="rechargeForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="rechargeFormCommit" :loading="rechargeFormCommiting">确 定</el-button>
          <el-button @click="rechargeFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 转账 -->
      <el-dialog title="转账" :visible.sync="transferFormVisible">
        <el-form :model="transferForm" ref="transferForm" :rules="transferFormRules" label-width="200px">
          <el-form-item label="转出卡号">
            {{ transferForm.card_no }}
          </el-form-item>
          <el-form-item label="持卡人">
            {{ transferForm.card_name }}
          </el-form-item>
          <el-form-item label="当前余额">
            {{ transferForm.balance }}
          </el-form-item>
          <el-form-item label="转入卡号" prop="card_no_2">
            <el-input v-model="transferForm.card_no_2" @change="updateTransferRemark">
              <el-button slot="append" @click="checkCardNo2">检查卡号</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="持卡人">
            {{ transferForm.card_name_2 }}
          </el-form-item>
          <el-form-item prop="oper_money" label="转账金额">
            <el-input v-model.number="transferForm.oper_money" @change="updateTransferRemark" style="width:194px;"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="transferForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="transferFormCommit" :loading="transferFormCommiting">确 定</el-button>
          <el-button @click="transferFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
      <el-dialog title="修改充值卡密码" :visible.sync="passwordFormVisible">
        <el-form :model="passwordForm" ref="passwordForm" :rules="passwordFormRules" label-width="200px">
          <el-form-item label="当前密码" prop="oldpass">
            <el-input type="password" v-model="passwordForm.oldpass" style="width:194px;"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newpass">
            <el-input type="password" v-model="passwordForm.newpass" style="width:194px;"></el-input>
          </el-form-item>
          <el-form-item label="再次输入新密码" prop="newpass2">
            <el-input type="password" v-model="passwordForm.newpass2" style="width:194px;"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="passwordFormCommit" :loading="passwordFormCommiting">确 定</el-button>
          <el-button @click="passwordFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
      <el-dialog title="修改手机号" :visible.sync="phoneFormVisible">
        <el-form :model="phoneForm" ref="phoneForm" label-width="200px">
          <el-form-item label="卡号">
            {{ phoneForm.card_no }}
          </el-form-item>
          <el-form-item label="手机号" prop="phone" required>
            <el-input v-model="phoneForm.phone" style="width:194px;" placeholder="请输入手机号"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="phoneFormCommit" :loading="phoneFormCommiting">确 定</el-button>
          <el-button @click="phoneFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
      <card-history-dialog :visible="historyVisible" :card-no="historyCardNo" :user="user" @close="historyVisible = false"></card-history-dialog>
    </div>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import moment from 'moment'
import CardHistoryDialog from './CardHistoryDialog'
import NP from 'number-precision'
export default {
  components: {
    CardHistoryDialog
  },
  mixins: [ListFunc],
  data () {
    return {
      sqlcode: 'card_list',
      searchForm: {
        query: ''
      },
      addForm: {
        card_no: '',
        card_name: '',
        phone: ''
      },
      addFormRules: {
        card_no: [
          { required: true, message: "请输入卡号或读取身份证", trigger: "blur" }
        ],
        card_name: [
          { required: true, message: "请输入持卡人姓名", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入持卡人手机号", trigger: "blur" }
        ]
      },
      addFormVisible: false,
      addFormCommiting: false,
      rechargeForm: {
        id: 0,
        card_no: '',
        card_name: '',
        balance: 0,
        oper_money: 0,
        pay_money: 0,
        pay_type: '现金',
        fin_account: '',
        fin_person: '',
        fin_no: '',
        remark: '',
        free_rate: 1,
        free_money: 0
      },
      rechargeFormRules: {
        oper_money: [
          { required: true, message: "请输入充值金额", trigger: "blur" }
        ],
        pay_money: [
          { required: true, message: "请输入实际支付金额", trigger: "blur" }
        ]
      },
      rechargeFormVisible: false,
      rechargeFormCommiting: false,
      transferForm: {
        id: 0,
        card_no: '',
        card_name: '',
        balance: 0,
        card_no_2: '',
        card_name_2: '',
        oper_money: 0,
        remark: ''
      },
      transferFormRules: {
        oper_money: [
          {
            validator: (rule, value, callback) => {
              if (value === '' || value === '0' || value === 0) {
                callback(new Error('请输入转账金额'))
              } else if (value > this.transferForm.balance) {
                callback(new Error('转账金额不能大于当前余额'))
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        card_no_2: [
          { required: true, message: "请输入转入卡号", trigger: "blur" }
        ]
      },
      transferFormVisible: false,
      transferFormCommiting: false,
      historyVisible: false,
      historyCardNo: '',
      selectRow: null,
      passwordFormVisible: false,
      passwordForm: {
        oldpass: '',
        newpass: '',
        newpass2: ''
      },
      passwordFormRules: {
        oldpass: [
          { required: true, message: "请输入当前密码", trigger: "blur" }
        ],
        newpass: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入新密码'));
              } else {
                if (this.passwordForm.newpass2 !== '') {
                  this.$refs.passwordForm.validateField('newpass2')
                }
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        newpass2: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入新密码'))
              } else if (value !== this.passwordForm.newpass) {
                callback(new Error('两次输入密码不一致!'))
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      },
      passwordFormCommiting: false,
      phoneForm: {
        id: 0,
        card_no: '',
        phone: ''
      },
      phoneFormVisible: false,
      phoneFormCommiting: false,
      czmin: 0, //最低充值
      accountList: []
    }
  },
  computed: {
    accountListFilter () {
      if (this.rechargeForm.pay_type === '现金') {
        return this.accountList.filter(i => i.account_type === '现金')
      } else if (this.rechargeForm.pay_type === '支付宝') {
        return this.accountList.filter(i => i.account_type === '支付宝')
      } else if (this.rechargeForm.pay_type === '微信支付') {
        return this.accountList.filter(i => i.account_type === '微信')
      } else if (this.rechargeForm.pay_type === '刷卡') {
        return this.accountList.filter(i => i.account_type === '银行')
      } else if (this.rechargeForm.pay_type === '转账') {
        return this.accountList.filter(i => i.account_type === '银行')
      } else {
        return this.accountList
      }
    }
  },
  mounted () {
    this.loadChargeParams()
    this.fetchAccountList()
  },
  methods: {
    loadChargeParams () { // 加载充值参数
      this.$http.get('/dbapi/group_charge_params').then(response => {
        if (response.data.success && response.data.list.length > 0) {
          this.czmin = response.data.list[0].czmin
          this.rechargeForm.free_rate = response.data.list[0].czxs
        }
      })
    },
    fetchAccountList () {
      this.$http.get('/dbapi/fin_account_combo').then(response => {
        if (response.data.success) {
          this.accountList = response.data.list
          if (this.accountList.length > 0) {
            this.rechargeForm.fin_account = this.accountList[0].id
          }
        }
      })
    },
    payTypeChange () {
      if (this.accountListFilter.length > 0) {
        this.rechargeForm.fin_account = this.accountListFilter[0].id
      }
    },
    addFormCommit () { // 添加新充值卡
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (!/\w/.test(this.addForm.card_no)) {
            this.$alert('卡号只能是字母或数字', 'xx错误xx', {
              confirmButtonText: '我知道了'
            })
            return
          }
          this.addFormCommiting = true
          this.$http.get('/dbapi/card_info?card_no=' + this.addForm.card_no).then(response => {
            if (response.data.success) {
              if (response.data.list.length > 0) {
                return Promise.reject('卡号已存在,请检查')
              }
              return this.$http.get('/dbapi/card_info?phone=' + this.addForm.phone)
            } else {
              return Promise.reject(response.data.message)
            }
          }).then(response => {
            if (response.data.success) {
              if (response.data.list.length > 0) {
                return Promise.reject('手机号已存在,请检查')
              }
              return this.$http.post('/dbapi/insert_card', this.addForm)
            } else {
              return Promise.reject(response.data.message)
            }
          }).then(response => {
            this.addFormCommiting = false
            if (response.data.success) {
              this.$refs.addForm.resetFields()
              this.addFormVisible = false
              this.refresh()
              this.$message({
                type: 'success',
                message: '充值卡添加成功'
              })
            } else {
              return Promise.reject(response.data.message)
            }
          }).catch(msg => {
            this.addFormCommiting = false
            this.$message({
              type: 'error',
              message: msg
            })
          })
        }
      })
    },
    detail (card) {
      this.historyCardNo = card.card_no
      this.historyVisible = true
    },
    countOperMoney () {
      this.rechargeForm.oper_money = NP.times(this.rechargeForm.pay_money, this.rechargeForm.free_rate)
      this.rechargeForm.free_money = NP.minus(this.rechargeForm.oper_money, this.rechargeForm.pay_money)
    },
    recharge (card) {
      this.rechargeForm.id = card.id
      this.rechargeForm.card_no = card.card_no
      this.rechargeForm.card_name = card.card_name
      this.rechargeForm.balance = card.balance
      this.rechargeForm.fin_person = card.card_name
      this.rechargeForm.pay_money = 0
      this.rechargeForm.oper_money = 0
      this.rechargeForm.free_money = 0
      this.rechargeForm.remark = ''
      this.rechargeFormVisible = true
    },
    rechargeFormCommit () {
      if (this.rechargeForm.pay_money < this.czmin) {
        this.$message({
          type: 'error',
          message: '最低充值' + this.czmin + '元'
        })
        return
      }
      this.$refs.rechargeForm.validate(valid => {
        if (valid) {
          this.rechargeFormCommiting = true
          this.$http.post('/dbapi/card_recharge', this.rechargeForm).then(response => {
            this.rechargeFormCommiting = false
            if (response.data.success) {
              this.$refs.rechargeForm.resetFields()
              this.rechargeFormVisible = false
              this.refresh()
              this.$message({
                type: 'success',
                message: '充值成功'
              })
              this.$http.get('/dbapi/card_history?id=' + response.data.insertId).then(response => {
                if (response.data.success && response.data.list.length > 0) {
                  let fin_id = response.data.list[0].fin_id
                  this.$confirm('是否要现在打印收据?', '提示', {
                    confirmButtonText: '现在打印',
                    cancelButtonText: '稍后打印',
                    type: 'warning'
                  }).then(() => {
                    window.open(this.$http.receiptBaseUrl + '/fin_print?ids=' + fin_id + '&token=' + localStorage.getItem('kaochang.token'))
                  })
                }
              })
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    updateRechargeRemark () {
      try {
        let balance = this.rechargeForm.balance
        balance = parseInt(this.rechargeForm.balance) + parseInt(this.rechargeForm.oper_money)
        this.rechargeForm.remark = `充值后余额${balance}元`
      } catch (e) {
        console.log(e)
      }
      /*
      if (this.rechargeForm.pay_money < this.rechargeForm.oper_money) {
        let m = this.rechargeForm.oper_money - this.rechargeForm.pay_money
        this.rechargeForm.remark = `充${this.rechargeForm.pay_money}送${m}元,充值后余额${balance}元`
      } else {
        this.rechargeForm.remark = `充值后余额${balance}元`
      }
      */
    },
    transfer (card) {
      this.transferForm.id = card.id
      this.transferForm.card_no = card.card_no
      this.transferForm.card_name = card.card_name
      this.transferForm.card_no_2 = ''
      this.transferForm.card_name_2 = ''
      this.transferForm.balance = card.balance
      this.transferFormVisible = true
    },
    checkCardNo2 () {
      if (this.transferForm.card_no_2.length > 1) {
        this.$http.get('/dbapi/card_info?card_no=' + this.transferForm.card_no_2).then(response => {
          if (response.data.success) {
            if (response.data.list.length > 0) {
              this.transferForm.card_name_2 = response.data.list[0].card_name
            } else {
              this.$message({
                type: 'error',
                message: '卡号错误,请检查'
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      }
    },
    transferFormCommit () {
      this.$refs.transferForm.validate(valid => {
        if (valid) {
          this.transferFormCommiting = true
          this.$http.post('/dbapi/card_transfer', this.transferForm).then(response => {
            this.transferFormCommiting = false
            if (response.data.success) {
              this.$refs.transferForm.resetFields()
              this.transferFormVisible = false
              this.refresh()
              this.$message({
                type: 'success',
                message: '转账成功'
              })
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    updateTransferRemark () {
      this.transferForm.remark = `${this.transferForm.card_no}向${this.transferForm.card_no_2}转账${this.transferForm.oper_money}元`
    },
    changePassword (row) {
      this.selectRow = row
      this.passwordFormVisible = true
    },
    resetPassword (row) {
      this.$confirm('确定要重置密吗？重置后密码为123456', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/card_reset_pwd', {
          id: row.id
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '密码已重置为123456'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    passwordFormCommit () {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          if (this.passwordForm.oldpass !== this.selectRow.password) {
            this.$message({
              type: 'error',
              message: '当前密码输入错误'
            })
            return
          }
          this.passwordFormCommiting = true
          this.$http.post('/dbapi/card_update_pwd', {
            id: this.selectRow.id,
            password: this.passwordForm.newpass
          }).then(response => {
            this.passwordFormCommiting = false
            if (response.data.success) {
              this.passwordFormVisible = false
              this.refresh()
              this.$message({
                type: 'success',
                message: '密码修改成功'
              })
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    changePhone (row) {
      this.phoneForm.id = row.id
      this.phoneForm.card_no = row.card_no
      this.phoneForm.phone = row.phone
      this.phoneFormVisible = true
    },
    phoneFormCommit () {
      this.$refs.phoneForm.validate(valid => {
        if (valid) {
          this.phoneFormCommiting = true
          this.$http.post('/dbapi/update_card_phone', this.phoneForm).then(response => {
            this.phoneFormCommiting = false
            if (response.data.success) {
              this.phoneFormVisible = false
              this.refresh()
              this.$message({
                type: 'success',
                message: '手机号修改成功'
              })
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/card/Card.vue